const WIX_STATIC_MEDIA_PATH = 'https://static.wixstatic.com/media/';
const MEDIA_PREFIX = 'media/';
export const extractMediaUri = uri => {
  if (uri.startsWith(WIX_STATIC_MEDIA_PATH)) {
    const mediaUri = uri.replace(WIX_STATIC_MEDIA_PATH, '');
    return mediaUri.split('/')[0];
  } else if (uri.startsWith(MEDIA_PREFIX)) {
    const mediaUri = uri.replace(WIX_STATIC_MEDIA_PATH, '');
    return mediaUri.split('/')[1];
  } else {
    return uri;
  }
};
//# sourceMappingURL=extract-media-uri.js.map